import React from 'react';
import { Route, Routes } from 'react-router';
import { Header, Tenant, Title, SubTitle } from '../../components/content/page-header';
import { Sidebar, SidebarLink } from '../../components/layout/sidebar';
import { ContentWrapper } from '../../components/layout/content';
import { Logs } from './logs';
import { Jobs } from './jobs';

export const Reports = (): JSX.Element => {
  return <div>
    <Header>
      <Tenant />
      <Title>Reporting</Title>
      <SubTitle>DisasterAWARE configuration settings.</SubTitle>
    </Header>
    <div>
      <Sidebar>
        <SidebarLink to="/reports">Change Log</SidebarLink>
        <SidebarLink to="/reports/jobs">Job Management</SidebarLink>
      </Sidebar>
      <ContentWrapper>
        <Routes>
          <Route path="/" element={<Logs />} />
          <Route path="/jobs" element={<Jobs />} />
        </Routes>
      </ContentWrapper>
    </div>
  </div>;
};
